import React from "react";
import { Link } from "react-router-dom";
import "./css/Newfooter.css";
import userStore from "../../zustand/userStore";

const Newfooter = () => {
  // return (
  //   <footer className="quiz-landing-footer">
  //     <div className="container-fluid text-start">
  //       <div className="row">
  //         {/* Company Info */}
  //         <div className="col-md-3">
  //           <Link className="navbar-brand footer-logo-container" to="/quizhomepage">
  //             <img
  //               src="../images/docmasterLogo.png"
  //               alt="DocMaster Quiz Logo"
  //               className="quiz-landing-logo"
  //             />
  //           </Link>
  //           <div className="footer-description">
  //             <p className="text-15 mb-0">
  //               Empowering students through interactive learning and competitive quizzes.
  //               Building the future of education, one question at a time.
  //             </p>
  //           </div>
  //         </div>

  //         {/* Quick Links */}
  //         <div className="col-md-3">
  //           <h5 className="footer-heading">Quick Links</h5>
  //           <ul className="footer-links">
  //             <li>
  //               <Link to="/Newdashboard" className="footer-link">
  //                 Dashboard
  //               </Link>
  //             </li>
  //             <li>
  //               <Link to="/syllabus" className="footer-link">
  //                 Syllabus
  //               </Link>
  //             </li>
  //             <li>
  //               <Link to="/how-to-participate" className="footer-link">
  //                 How to Participate
  //               </Link>
  //             </li>
  //             <li>
  //               <Link to="/profile" className="footer-link">
  //                 Profile
  //               </Link>
  //             </li>
  //           </ul>
  //         </div>

  //         {/* Support */}
  //         <div className="col-md-3">
  //           <h5 className="footer-heading">Support</h5>
  //           <ul className="footer-links">
  //             <li>
  //               <Link to="/faq" className="footer-link">
  //                 FAQ's
  //               </Link>
  //             </li>
  //             <li>
  //               <Link to="/terms" className="footer-link">
  //                 Terms & Conditions
  //               </Link>
  //             </li>
  //             <li>
  //               <Link to="/contact" className="footer-link">
  //                 Contact Us
  //               </Link>
  //             </li>
  //             <li>
  //               <Link to="/testimonials" className="footer-link">
  //                 Testimonials
  //               </Link>
  //             </li>
  //           </ul>
  //         </div>

  //         {/* Contact Info */}
  //         <div className="col-md-3">
  //           <h5 className="footer-heading">Contact Info</h5>
  //           <ul className="footer-contact-list">
  //             <li>
  //               <a href="mailto:info@docmasterquiz.com" className="footer-link">
  //                 info@docmasterquiz.com
  //               </a>
  //             </li>
  //             <li>
  //               <a href="tel:+919876543210" className="footer-link">
  //                 +91 98765 43210
  //               </a>
  //             </li>
  //             <li>
  //               <span className="footer-link">Mumbai, Maharashtra, India</span>
  //             </li>
  //           </ul>
  //           <div className="footer-social-icons">
  //             <a href="#" className="social-icon" aria-label="Facebook">
  //               <i className="fab fa-facebook"></i>
  //             </a>
  //             <a href="#" className="social-icon" aria-label="Twitter">
  //               <i className="fab fa-twitter"></i>
  //             </a>
  //             <a href="#" className="social-icon" aria-label="Instagram">
  //               <i className="fab fa-instagram"></i>
  //             </a>
  //             <a href="#" className="social-icon" aria-label="LinkedIn">
  //               <i className="fab fa-linkedin"></i>
  //             </a>
  //           </div>
  //         </div>
  //       </div>

  //       <hr className="footer-divider" />
  //       <p className="footer-copyright">© 2024 DocMaster Quiz. All rights reserved.</p>
  //     </div>
  //   </footer>
  // );
  const userData = userStore((state) => state.user);
  console.log("userData", JSON.stringify(userData?.role));
  return (
    <footer
      className="bg-footer text-light pt-1 hide-mobile"
      style={{
        position: "relative",
        zIndex: "2",
        background:
          "linear-gradient(90deg, rgba(19,55,131,0.9), rgba(27, 170, 85, 0.9)",
      }}
    >
      <div className="container-fluid">
        <div className="row  d-flex justify-content-center align-items-center">
          <div className="">
            <p className="mb-1 text-center">
              <nav class="footer-nav text-center justify-content-center">
                <a
                  href="/About#aboutus"
                  class="text-light mx-2 text-16 md:text-18"
                  target="_blank"
                >
                  About Us
                </a>
                |
                <a
                  href="/About#Disclaimer"
                  target="_blank"
                  class="text-light mx-2 text-16 md:text-18"
                >
                  Disclaimer
                </a>
                |
                <a
                  href="/About#TearmsConditions"
                  target="_blank"
                  class="text-light mx-2 text-16 md:text-18"
                >
                  Terms & Conditions
                </a>
                |
                <a
                  href="/About#PrivacyPolicy"
                  class="text-light mx-2 text-16 md:text-18"
                  target="_blank"
                >
                  Privacy Policy
                </a>
                |
                <a
                  href="/About#ipr-el"
                  class="text-light mx-2 text-16 md:text-18"
                  target="_blank"
                >
                  IPR &amp; Copyright
                </a>
                |
                <a href="/pricing" class="text-light mx-2 text-16 md:text-18">
                  Pricing Plan
                </a>
                |
                <a
                  href="/About#CPolicy"
                  class="text-light mx-2 text-16 md:text-18"
                >
                  Refund & Cancellation policy
                </a>
                |
                <a
                  href="/About#faq"
                  class="text-light mx-2 text-16 md:text-18"
                  target="_blank"
                >
                  FAQs
                </a>
                |
                {userData?.admin_id && userData?.role !== "student" && (
                  <>
                    <a
                      // href="/raiseYourConcern"
                      href="/view-tickets"
                      class="text-light mx-2 text-16 md:text-18"
                      target="_blank"
                    >
                      Raise Your Concern
                    </a>
                    |
                  </>
                )}
                {userData?.role !== "student" && (
                  <a
                    href="/About#Contact"
                    class="text-light mx-2 text-16 md:text-18"
                    target="_blank"
                  >
                    Contact Us
                  </a>
                )}
                {userData?.role !== "student" && <>|</>}
                {/* <a href="/About#PricingPlan" class="text-dark mx-2 text-16 md:text-18" target="_blank">
                  Pricing Plan
                </a>
                |
                <a
                  class="text-dark mx-2 text-16 md:text-18"
                  target="_blank"
                  href="/About#CPolicy"
                >
                  Cancellation & Refund Policy
                </a>
                | */}
                {/* <a
                  href="https://wa.me/9289440049"
                  target="_blank"
                  class="footer-link mx-1"
                  rel="noreferrer"
                >
                  <i className="fa fa-phone-square"></i>
                  <img src="images/WApp_icon.png" width={20} />
                </a> */}
                {/* <a
                  href="https://www.facebook.com/docmasterin/"
                  target="_blank"
                  class="footer-link mx-1"
                  rel="noreferrer"
                >
                  <img src="/images/fb.png" width={16} alt="Facebook" />
                </a>
                <a
                  href="https://www.linkedin.com/company/78317523/admin/dashboard/"
                  target="_blank"
                  class="footer-link mx-1"
                  rel="noreferrer"
                >
                  <img src="/images/li.png" width={16} alt="LinkedIn" />
                </a>
                <a
                  href="https://www.instagram.com/docmaster_in/"
                  target="_blank"
                  class="footer-link mx-1"
                  rel="noreferrer"
                >
                  <img src="/images/Instagram.png" width={16} alt="Instagram" />
                </a>
                <a
                  href="https://x.com/Docmaster_in"
                  target="_blank"
                  class="footer-link mx-1"
                  rel="noreferrer"
                >
                  <img src="/images/twitter.png" width={16} alt="Twitter" />
                </a>
                <a
                  href="https://youtube.com/@mydocmaster"
                  target="_blank"
                  class="footer-link mx-1"
                  rel="noreferrer"
                >
                  <img src="/images/yt.png" width={25} alt="YouTube" />
                </a> */}
              </nav>
            </p>
          </div>
        </div>
      </div>
    </footer>
    // <footer
    //   className="footer bg-light border-top"
    //   style={{
    //     height: "40px",
    //     display: "flex",
    //     alignItems: "center",
    //     justifyContent: "center",
    //     fontSize: "14px",
    //   }}
    // >
    //   <span className="text-muted">
    //     <strong>
    //       © {new Date().getFullYear()} Docmaster. All rights reserved.
    //     </strong>
    //   </span>
    // </footer>
  );
};

export default Newfooter;
